import { renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { ref, computed } from "vue";
import { Field } from "vant";
import SvgIcon from "./SvgIcon.vue";
export default {
  __name: 'Input',
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    selfType: {
      type: String,
      // default、borderBottom、borderTextarea
      default: "default"
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var selfInput = ref();
    var props = __props;
    var emits = __emit;
    var value = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(val) {
        emits("update:modelValue", val);
      }
    });
    function handleClear() {
      emits("update:modelValue", "");
    }
    __expose({
      focus: function focus() {
        var _selfInput$value;
        (_selfInput$value = selfInput.value) === null || _selfInput$value === void 0 || _selfInput$value.focus();
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["self-input", {
          'self-input-border-bottom': __props.selfType === 'borderBottom',
          'self-input-border-textarea': __props.selfType === 'borderTextarea',
          'self-input--error': __props.error
        }])
      }, [_createVNode(_unref(Field), _mergeProps({
        ref_key: "selfInput",
        ref: selfInput,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return value.value = $event;
        }),
        "label-align": "top"
      }, _ctx.$attrs), {
        "right-icon": _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "right-icon"), __props.allowClear ? _withDirectives((_openBlock(), _createBlock(SvgIcon, {
            key: 0,
            class: "flex",
            name: "clear",
            size: 16,
            onClick: handleClear
          }, null, 512)), [[_vShow, value.value.length > 0]]) : _createCommentVNode("", true)];
        }),
        _: 3
      }, 16, ["modelValue"])], 2);
    };
  }
};